/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBlobFilled = createReactComponent("filled", "blob-filled", "IconBlobFilled", [["path", { "d": "M12 3c2.78 0 5.349 1.556 7.243 4.083c1.727 2.305 2.757 5.257 2.757 8.015c0 1.47 -.293 2.717 -.903 3.745c-.602 1.014 -1.479 1.758 -2.582 2.256c-1.593 .719 -3.333 .901 -6.515 .901s-4.922 -.182 -6.515 -.9c-1.103 -.499 -1.98 -1.243 -2.582 -2.257c-.61 -1.028 -.903 -2.274 -.903 -3.745c0 -2.758 1.03 -5.71 2.757 -8.015c1.894 -2.527 4.463 -4.083 7.243 -4.083", "key": "svg-0" }]]);

export { IconBlobFilled as default };
//# sourceMappingURL=IconBlobFilled.mjs.map
